import { render } from "./Mission.vue?vue&type=template&id=4fbaf40a"
import script from "./Mission.vue?vue&type=script&lang=js"
export * from "./Mission.vue?vue&type=script&lang=js"
script.render = render

export default script